'use client';

import { atom } from 'jotai';

export const hasClickedApplyFinanceAtom = atom(false);
